module.exports = __webpack_public_path__ + "static/media/click-collect-empty.ecc25003.svg";